import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import { normalizeNode, shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, shouldHaveChildrenOfType } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeKeyboardBlockShortcut from '../utils/makeKeyboardBlockShortcut';
import makeMarkdownBlockShortcut from '../utils/makeMarkdownBlockShortcut';
import makeToolbarButton, { BASIC_SELECTION, EXPANDED_SELECTION, BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import Todo from './components/Todo';
import { CheckboxIcon } from '../../components/Icons';
import toggleSelectedTodos from './utils/toggleSelectedTodos';
import onKeyDown from './handlers/onKeyDown';
import serializers from './serializers';
import deserializers from './deserializers';
export default (function () {
  var _renderBlocks;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator;

  var Component = function Component(props) {
    return React.createElement(Todo, props);
  };

  return [normalizeNode(BlockTypes.TODOS, [shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, [shouldHaveChildrenOfType, BlockTypes.TODO]]), {
    serializers: serializers,
    deserializers: deserializers,
    onKeyDown: onKeyDown
  }, renderBlocks((_renderBlocks = {}, _defineProperty(_renderBlocks, BlockTypes.TODOS, function (props) {
    return props.children;
  }), _defineProperty(_renderBlocks, BlockTypes.TODO, decorator(Component)), _renderBlocks)), makeKeyboardBlockShortcut('mod+shift+c', BlockTypes.TODO), makeMarkdownBlockShortcut(/^(-?\[.?\])$/, BlockTypes.TODO, {
    onlyOnBlocksOfTypes: [BlockTypes.UNSTYLED, BlockTypes.UL_LI],
    onApply: function onApply(editor, event, matches) {
      var isChecked = /^-?\[x\]$/i.test(matches.before[0]);
      editor.setBlocks(BlockTypes.TODO);
      return toggleSelectedTodos(editor, isChecked);
    }
  }), makeToolbarButton(BlockTypes.TODO, {
    icon: CheckboxIcon,
    title: 'Checklist',
    alias: ['todo'],
    visibility: BASIC_SELECTION | EXPANDED_SELECTION | BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.TODO);
    },
    onApply: function onApply(editor) {
      return editor.toggleBlock(BlockTypes.TODO);
    }
  })];
});